/**
 * @documental
 * @export Spread
 * @name
 * Grid.Spread
 */

import { FC, ReactNode } from "react";

/**
 * The `Spread` component properties.
 */
export interface SpreadProps {
  /**
   * The number of columns between 1 and 12 to spread each child across. If each child that exceeds the bounds of
   * the grid will be placed on the following row.
   */
  readonly columns: number;

  /**
   * The components to spead.
   */
  readonly children?: ReactNode | Iterable<ReactNode> | null | false;
}

/**
 * A component which spreads each of its children and out the specified number of columns across the `Grid`.
 */
export const Spread: FC<SpreadProps> = () => {
  return null;
};
